import React, { useState, useEffect } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import './CadastroPedidoVenda.css';

const CadastroPedidoVenda = () => {
  const _url = URLManager.getBaseURL();

  // Estados principais
  const [clientes, setClientes] = useState([]);
  const [dataPedido, setDataPedido] = useState('');
  const [status, setStatus] = useState('Pendente');
  const [produtoId, setProdutoId] = useState('');
  const [idCliente, setIdCliente] = useState('');
  const [cor, setCor] = useState('');

  const [descricao,setDescricao] = useState('');

  const [produtos, setProdutos] = useState([]);
  
  const [cores, setCores] = useState([]);
  const [grade, setGrade] = useState([]);
  const [numero, setNumero] = useState('');
  const [quantidade, setQuantidade] = useState('');
  
  // Estados para intervalo de numeração
  const [numeroInicial, setNumeroInicial] = useState('');
  const [numeroFinal, setNumeroFinal] = useState('');
  const [gradeGerada, setGradeGerada] = useState([]);
  const [modoGrade, setModoGrade] = useState('manual'); // 'manual' ou 'intervalo'
  
  // Estados de controle
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clienteLoading, setClienteLoading] = useState(false);
  const [showClienteModal, setShowClienteModal] = useState(false);
  const [showListaClientesModal, setShowListaClientesModal] = useState(false);
  const [buscaCliente, setBuscaCliente] = useState('');
  const [clienteSelecionado, setClienteSelecionado] = useState('');
  const [buscaProduto, setBuscaProduto] = useState('');
  const [produtoSelecionado, setProdutoSelecionado] = useState('');
  const [clienteInputFocado, setClienteInputFocado] = useState(false);
  const [produtoInputFocado, setProdutoInputFocado] = useState(false);
  const [novoCliente, setNovoCliente] = useState({
    nomeCliente: '',
    contato: '',
    email: '',
    endereco: '',
    cnpj: ''
  });

  // Função para mostrar mensagem
  const mostrarMensagem = (mensagem, tipo = 'success') => {
    setFeedback({ type: tipo, message: mensagem });
    setTimeout(() => setFeedback(null), 5000);
  };

  // Função para filtrar clientes por nome ou CNPJ
  const clientesFiltrados = clientes.filter((cliente) => {
    const termoBusca = buscaCliente.toLowerCase();
    const nome = (cliente.nomeCliente || '').toLowerCase();
    const email = (cliente.email || '').toLowerCase();
    const cnpj = (cliente.cnpj || '').toLowerCase();
    return nome.includes(termoBusca) || email.includes(termoBusca) || cnpj.includes(termoBusca);
  });

  // Função para selecionar cliente
  const selecionarCliente = (valor) => {
    const cliente = clientes.find(c => 
      (c.idCliente && c.idCliente.toString() === valor) || 
      (c.id && c.id.toString() === valor)
    );
    
    if (cliente) {
      setIdCliente(cliente.idCliente || cliente.id);
      setClienteSelecionado(`${cliente.nomeCliente} / CNPJ: ${cliente.cnpj}`);
      setBuscaCliente('');
    }
  };

  // Função para filtrar produtos por nome
  const produtosFiltrados = produtos.filter((produto) => {
    const termoBusca = buscaProduto.toLowerCase();
    const nome = (produto.nomeModelo || produto.nome || produto.descricao || '').toLowerCase();
    return nome.includes(termoBusca);
  });

  // Função para selecionar produto
  const selecionarProduto = (valor) => {
    const produto = produtos.find(p => 
      (p.idProduto && p.idProduto.toString() === valor) ||
      (p.id && p.id.toString() === valor)
    );

    if (produto) {
      const id = produto.idProduto || produto.id;
      setProdutoId(id);
      setProdutoSelecionado(produto.nomeModelo || produto.nome || produto.descricao || `Produto ${id}`);
      setBuscaProduto('');
      setCor('');
    }
  };

   // Carregar clientes ao montar
  useEffect(() => {
    fetch(`${_url}/cliente/listar`, {
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
      }
    })
      .then(res => res.json())
      .then(data => setClientes(data || []))
      .catch(() => {
        setClientes([]);
        mostrarMensagem('Erro ao carregar clientes', 'error');
      });
  }, [_url]);

  // Carregar produtos ao montar
  useEffect(() => {
    fetch(`${_url}/produto/so-pais`, {
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
      }
    })
      .then(res => res.json())
      .then(data => setProdutos(data || []))
      .catch(() => {
        setProdutos([]);
        mostrarMensagem('Erro ao carregar produtos', 'error');
      });
  }, [_url]);

  // Buscar variações/cores ao selecionar produto
  useEffect(() => {
    if (!produtoId || produtoId === '' || produtoId === undefined) {
      setCores([]);
      setCor('');
      return;
    }
    
    // Buscar cores do produto pai e filhos
    Promise.all([
      // Cores do produto pai
      fetch(`${_url}/produto/${produtoId}`, {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      }).then(res => res.ok ? res.json() : null),
      // Cores das variações (filhos)
      fetch(`${_url}/produto/${produtoId}/variacoes`, {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      }).then(res => res.ok ? res.json() : [])
    ])
      .then(([produtoPai, variacoes]) => {
        const coresSet = new Set();
        
        // Adicionar cor do produto pai se existir
        if (produtoPai && produtoPai.cor) {
          coresSet.add(produtoPai.cor);
        }
        
        // Adicionar cores das variações
        if (Array.isArray(variacoes)) {
          variacoes.forEach(v => {
            if (v.cor) coresSet.add(v.cor);
          });
        }
        
        setCores(Array.from(coresSet).sort());
      })
      .catch(() => setCores([]));
  }, [produtoId, _url]);

  // Gera grade por intervalo
  const gerarGradeIntervalo = (e) => {
    e.preventDefault();
    
    if (!numeroInicial || !numeroFinal) {
      mostrarMensagem('Preencha o número inicial e final', 'error');
      return;
    }
    
    const inicio = Number(numeroInicial);
    const fim = Number(numeroFinal);
    
    if (isNaN(inicio) || isNaN(fim)) {
      mostrarMensagem('Digite números válidos', 'error');
      return;
    }
    
    if (inicio > fim) {
      mostrarMensagem('O número inicial deve ser menor ou igual ao final', 'error');
      return;
    }
    
    const novaGrade = [];
    for (let i = inicio; i <= fim; i++) {
      novaGrade.push({ numero: String(i), quantidade: 0 });
    }
    
    setGradeGerada(novaGrade);
  };

  // Modal: abrir/fechar
  const abrirClienteModal = () => {
    setNovoCliente({ nomeCliente: '', contato: '', endereco: '', cnpj: '' });
    setShowClienteModal(true);
  };

  const fecharClienteModal = () => {
    setShowClienteModal(false);
  };

  const abrirListaClientesModal = () => {
    setShowListaClientesModal(true);
  };

  const fecharListaClientesModal = () => {
    setShowListaClientesModal(false);
  };

  // Cadastrar novo cliente
  const cadastrarNovoCliente = async (e) => {
    e.preventDefault();
    if (!novoCliente.nomeCliente || !novoCliente.email || !novoCliente.contato || !novoCliente.endereco || !novoCliente.cnpj) {
      mostrarMensagem('Informe nome, email, contato, endereço e CNPJ do cliente', 'error');
      return;
    }

    try {
      setClienteLoading(true);
      const res = await fetch(`${_url}/cliente/cadastrar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
        body: JSON.stringify(novoCliente)
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.message || 'Erro ao cadastrar cliente');
      }

      // Recarrega a lista de clientes e seleciona o novo
      try {
        const listaRes = await fetch(`${_url}/cliente/listar`, {
          headers: { 'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}` }
        });
        const lista = await listaRes.json();
        setClientes(lista || []);
        // Tenta selecionar pelo id retornado, ou pelo CNPJ
        const novoId = data?.idCliente || data?.id;
        if (novoId) {
          setIdCliente(String(novoId));
        } else {
          const encontrado = (lista || []).find(c => c.cnpj === novoCliente.cnpj);
          if (encontrado) setIdCliente(String(encontrado.idCliente || encontrado.id));
        }
      } catch {}

      mostrarMensagem('Cliente cadastrado com sucesso!', 'success');
      fecharClienteModal();
    } catch (err) {
      mostrarMensagem(err.message || 'Erro ao cadastrar cliente', 'error');
    } finally {
      setClienteLoading(false);
    }
  };
  
  // Atualiza quantidade na grade gerada
  const atualizarQuantidadeGrade = (index, valor) => {
    const novaGrade = [...gradeGerada];
    novaGrade[index].quantidade = valor === '' ? 0 : Number(valor);
    setGradeGerada(novaGrade);
  };
  
  // Confirma grade gerada
  const confirmarGradeIntervalo = () => {
    const gradeValida = gradeGerada.filter(item => item.quantidade > 0);
    
    if (gradeValida.length === 0) {
      mostrarMensagem('Adicione quantidade para pelo menos um número', 'error');
      return;
    }
    
    setGrade(gradeValida);
    setGradeGerada([]);
    setNumeroInicial('');
    setNumeroFinal('');
    mostrarMensagem('Grade adicionada com sucesso!', 'success');
  };

  // Adiciona item à grade (modo manual)
  const adicionarItemGrade = (e) => {
    e.preventDefault();
    if (!numero || !quantidade || isNaN(quantidade) || quantidade <= 0) {
      mostrarMensagem('Preencha número e quantidade válidos', 'error');
      return;
    }
    
    // Verifica se o número já existe na grade
    if (grade.find(item => item.numero === numero)) {
      mostrarMensagem('Este número já foi adicionado na grade', 'error');
      return;
    }
    
    setGrade([...grade, { numero, quantidade: Number(quantidade) }]);
    setNumero('');
    setQuantidade('');
  };

  // Remove item da grade
  const removerItemGrade = (idx) => {
    setGrade(grade.filter((_, i) => i !== idx));
  };

  // Calcula total de pares
  const totalPares = grade.reduce((soma, item) => soma + item.quantidade, 0);

  // Limpar formulário
  const limparFormulario = () => {
    
    setDataPedido('');
    setStatus('Pendente');
    setProdutoId('');
    setIdCliente('');
    setCor('');
    setCores([]);
    setGrade([]);
    setNumero('');
    setQuantidade('');
    setDescricao('');
    setNumeroInicial('');
    setNumeroFinal('');
    setGradeGerada([]);
    setModoGrade('manual');
  };

  // Submeter formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validações

    if (!idCliente) {
      mostrarMensagem('Selecione um cliente', 'error');
      return;
    }

    if (!produtoId) {
      mostrarMensagem('Selecione um produto', 'error');
      return;
    }
    
    if (!cor) {
      mostrarMensagem('Selecione uma cor', 'error');
      return;
    }
    
    if (grade.length === 0) {
      mostrarMensagem('Adicione pelo menos um item na grade', 'error');
      return;
    }

    setFeedback(null);
    setLoading(true);
    
    // Converter grade para objeto {numero: quantidade}
    const gradeNumeracao = {};
    grade.forEach(item => {
      gradeNumeracao[item.numero] = item.quantidade;
    });

    const pedidoData = {
      idCliente: Number(idCliente),
      dataPedido,
      status,
      cor,
      gradeNumeracao,
      quantidadeTotal: totalPares,
      idProduto: Number(produtoId),
      descricao: descricao || ''
    };

    try {
      const res = await fetch(`${_url}/pedido-venda/${produtoId}/${idCliente}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
        body: JSON.stringify(pedidoData)
      });
      
      const data = await res.json();
      
      if (!res.ok) {
        throw new Error(data.message || data || 'Erro ao criar pedido');
      }
      
      mostrarMensagem('Pedido criado com sucesso!', 'success');
      limparFormulario();
      
    } catch (err) {
      mostrarMensagem(err.message || 'Erro ao criar pedido', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastro-pedido-container">
      <h2>Cadastro de Pedido de Venda</h2>
      
      <div className="clientes-actions">
        <button 
              type="button" 
              onClick={abrirListaClientesModal}
              className="btn-meus-clientes"
            >
              Meus Clientes
            </button>
        <button 
              type="button" 
              onClick={abrirClienteModal}
              className="btn-gerar-grade"
            >
              Cadastrar Cliente
            </button>
      </div>

      {showListaClientesModal && (
        <div className="modal-overlay" onClick={fecharListaClientesModal}>
          <div className="modal-content modal-lista-clientes" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Meus Clientes</h3>
              <button type="button" className="btn-fechar" onClick={fecharListaClientesModal}>×</button>
            </div>
            <div className="modal-body">
              {clientes.length === 0 ? (
                <p className="sem-clientes">Nenhum cliente cadastrado ainda.</p>
              ) : (
                <div className="tabela-clientes-wrapper">
                  <table className="tabela-clientes">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>CNPJ</th>
                        <th>Email</th>
                        <th>Contato</th>
                        <th>Endereço</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientes.map((cliente) => (
                        <tr key={cliente.idCliente || cliente.id}>
                          <td>{cliente.nomeCliente || '-'}</td>               
                          <td>{cliente.cnpj || '-'}</td>
                          <td>{cliente.email || '-'}</td>
                          <td>{cliente.contato || '-'}</td>
                          <td>{cliente.endereco || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn-secondary" onClick={fecharListaClientesModal}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {showClienteModal && (
        <div className="modal-overlay" onClick={fecharClienteModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Novo Cliente</h3>
              <button type="button" className="btn-fechar" onClick={fecharClienteModal}>×</button>
            </div>
            <form onSubmit={cadastrarNovoCliente} className="modal-form">
              <div className="form-group">
                <label>Nome do Cliente *</label>
                <input 
                  type="text" 
                  value={novoCliente.nomeCliente}
                  onChange={e => setNovoCliente({ ...novoCliente, nomeCliente: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Contato *</label>
                <input 
                  type="text" 
                  value={novoCliente.contato}
                  onChange={e => setNovoCliente({ ...novoCliente, contato: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Endereço *</label>
                <input 
                  type="text" 
                  value={novoCliente.endereco}
                  onChange={e => setNovoCliente({ ...novoCliente, endereco: e.target.value })}
                  required
                />
             
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input 
                  type="text" 
                  value={novoCliente.email}
                  onChange={e => setNovoCliente({ ...novoCliente, email: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label>CNPJ *</label>
                <input 
                  type="text" 
                  value={novoCliente.cnpj}
                  onChange={e => setNovoCliente({ ...novoCliente, cnpj: e.target.value })}
                  required
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={fecharClienteModal} disabled={clienteLoading}>Cancelar</button>
                <button type="submit" className="btn-salvar" disabled={clienteLoading}>{clienteLoading ? 'Cadastrando...' : 'Cadastrar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {feedback && (
        <div className={`feedback-message ${feedback.type}`}>
          {feedback.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="pedido-form">
        <div className="form-row">

          <div className="form-group">
            <label>Cliente *</label>
            <div className="cliente-busca-container">
              {clienteSelecionado ? (
                <div className="cliente-selecionado">
                  <span>{clienteSelecionado}</span>
                  <button 
                    type="button" 
                    className="btn-limpar-cliente"
                    onClick={() => {
                      setIdCliente('');
                      setClienteSelecionado('');
                      setBuscaCliente('');
                    }}
                    title="Limpar seleção"
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <>
                  <input
                    type="text"
                    className="input-busca-cliente"
                    placeholder="Digite o nome ou CNPJ do cliente..."
                    value={buscaCliente}
                    onChange={(e) => setBuscaCliente(e.target.value)}
                    onFocus={() => setClienteInputFocado(true)}
                    onBlur={() => setTimeout(() => setClienteInputFocado(false), 200)}
                  />
                  {(clienteInputFocado || buscaCliente) && clientesFiltrados.length > 0 && (
                    <div className="clientes-dropdown">
                      {clientesFiltrados.map((clie) => (
                        <div 
                          key={clie.idCliente || clie.id} 
                          className="cliente-item"
                          onClick={() => selecionarCliente((clie.idCliente || clie.id).toString())}
                        >
                          <div className="cliente-nome">{clie.nomeCliente}</div>
                          <div className="cliente-cnpj">CNPJ: {clie.cnpj}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
            <input type="hidden" value={idCliente} required />
          </div>
        

          <div className="form-group">
            <label>Data do Pedido *</label>
            <input 
              type="date" 
              value={dataPedido} 
              onChange={e => setDataPedido(e.target.value)} 
              required 
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Status</label>
            <select 
              value={status} 
              onChange={e => setStatus(e.target.value)}
            >
              <option value="Pendente">Pendente</option>
              <option value="Em Produção">Em Produção</option>
              <option value="Concluído">Concluído</option>
              <option value="Cancelado">Cancelado</option>
            </select>
          </div>

          <div className="form-group">
            <label>Produto *</label>
            <div className="produto-busca-container">
              {produtoSelecionado ? (
                <div className="produto-selecionado">
                  <span>{produtoSelecionado}</span>
                  <button
                    type="button"
                    className="btn-limpar-produto"
                    onClick={() => {
                      setProdutoId('');
                      setProdutoSelecionado('');
                      setBuscaProduto('');
                      setCor('');
                    }}
                    title="Limpar seleção"
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <>
                  <input
                    type="text"
                    className="input-busca-produto"
                    placeholder="Digite o nome do produto..."
                    value={buscaProduto}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setBuscaProduto(valor);

                      // Se o usuário escolher uma opção do datalist (valor é o id), seleciona o produto
                      const encontrado = produtos.find(p => 
                        (p.idProduto && p.idProduto.toString() === valor) ||
                        (p.id && p.id.toString() === valor)
                      );

                      if (encontrado) {
                        selecionarProduto((encontrado.idProduto || encontrado.id).toString());
                      }
                    }}
                    onFocus={() => setProdutoInputFocado(true)}
                    onBlur={() => setTimeout(() => setProdutoInputFocado(false), 200)}
                    required={!produtoId}
                  />
                  {(produtoInputFocado || buscaProduto) && produtosFiltrados.length > 0 && (
                    <div className="produtos-dropdown">
                      {produtosFiltrados.map((prod) => (
                        <div
                          key={prod.idProduto || prod.id}
                          className="produto-item"
                          onClick={() => selecionarProduto((prod.idProduto || prod.id).toString())}
                        >
                          <div className="produto-nome">{prod.nomeModelo || prod.nome || prod.descricao}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
            <input type="hidden" value={produtoId} />
          </div>
        </div>

        <div className="form-group">
          <label>Cor *</label>
          <select 
            value={cor} 
            onChange={e => setCor(e.target.value)} 
            required 
            disabled={!cores.length}
          >
            <option value="">Selecione uma cor...</option>
            {cores.map((corItem, idx) => (
              <option key={`cor-${idx}`} value={corItem}>
                {corItem}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Descrição</label>
          <textarea 
            value={descricao} 
            onChange={e => setDescricao(e.target.value)}
            placeholder="Observações adicionais sobre o pedido essa informação ira aparecer na nota fiscal..."
            rows="3"
          />
        </div>

        <fieldset className="grade-fieldset">
          <legend>Grade de Numeração</legend>
          
          {/* Seletor de modo */}
          <div className="modo-grade-selector">
            <label className="radio-label">
              <input 
                type="radio" 
                name="modoGrade" 
                value="manual"
                checked={modoGrade === 'manual'}
                onChange={() => {
                  setModoGrade('manual');
                  setGradeGerada([]);
                  setNumeroInicial('');
                  setNumeroFinal('');
                }}
              />
              <span>Manual (um por vez)</span>
            </label>
            <label className="radio-label">
              <input 
                type="radio" 
                name="modoGrade" 
                value="intervalo"
                checked={modoGrade === 'intervalo'}
                onChange={() => {
                  setModoGrade('intervalo');
                  setNumero('');
                  setQuantidade('');
                }}
              />
              <span>Por Intervalo</span>
            </label>
          </div>

          {/* Modo Manual */}
          {modoGrade === 'manual' && (
            <div className="grade-input-group">
              <input 
                type="text" 
                placeholder="Número (ex: 35, 36, 37...)" 
                value={numero} 
                onChange={e => setNumero(e.target.value)}
                className="input-numero"
              />
              <input 
                type="number" 
                placeholder="Quantidade" 
                value={quantidade} 
                onChange={e => setQuantidade(e.target.value)} 
                min={1}
                className="input-quantidade"
              />
              <button 
                type="button" 
                onClick={adicionarItemGrade}
                className="btn-adicionar-grade"
              >
                Adicionar
              </button>
            </div>
          )}

          {/* Modo Intervalo */}
          {modoGrade === 'intervalo' && (
            <>
              <div className="intervalo-input-group">
                <div className="intervalo-inputs">
                  <input 
                    type="number" 
                    placeholder="Número inicial (ex: 34)" 
                    value={numeroInicial} 
                    onChange={e => setNumeroInicial(e.target.value)}
                    className="input-intervalo"
                  />
                  <span className="intervalo-separator">até</span>
                  <input 
                    type="number" 
                    placeholder="Número final (ex: 42)" 
                    value={numeroFinal} 
                    onChange={e => setNumeroFinal(e.target.value)}
                    className="input-intervalo"
                  />
                  <button 
                    type="button" 
                    onClick={gerarGradeIntervalo}
                    className="btn-gerar-grade"
                  >
                    Gerar Grade
                  </button>
                </div>
              </div>

              {/* Grade gerada para preenchimento */}
              {gradeGerada.length > 0 && (
                <div className="grade-intervalo-container">
                  <h4>Preencha as quantidades:</h4>
                  <div className="grade-grid">
                    {gradeGerada.map((item, index) => (
                      <div key={`grade-temp-${index}`} className="grade-item">
                        <label className="numero-label">Nº {item.numero}</label>
                        <input 
                          type="number"
                          min="0"
                          value={item.quantidade || ''}
                          onChange={e => atualizarQuantidadeGrade(index, e.target.value)}
                          className="input-qtd-grade"
                          placeholder="0"
                        />
                      </div>
                    ))}
                  </div>
                  <button 
                    type="button" 
                    onClick={confirmarGradeIntervalo}
                    className="btn-confirmar-grade"
                  >
                    Confirmar Grade
                  </button>
                </div>
              )}
            </>
          )}
          

          {/* Lista de itens adicionados */}
          {grade.length > 0 && (
            <div className="grade-lista">
              <h4>Itens na Grade:</h4>
              <table>
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Quantidade</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {grade.map((item, idx) => (
                    <tr key={`grade-${idx}`}>
                      <td>{item.numero}</td>
                      <td>{item.quantidade}</td>
                      <td>
                        <button 
                          type="button" 
                          onClick={() => removerItemGrade(idx)}
                          className="btn-remover"
                        >
                          Remover
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
              <div className="total-pares">
                <strong>Total de pares: {totalPares}</strong>
              </div>
            </div>
          )}
        </fieldset>

        <div className="form-actions">
          <button 
            type="button" 
            onClick={limparFormulario}
            className="btn-limpar"
            disabled={loading}
          >
            Limpar
          </button>
          <button 
            type="submit" 
            disabled={!grade.length || !produtoId || !cor || loading}
            className="btn-salvar"
          >
            {loading ? 'Salvando...' : 'Salvar Pedido'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroPedidoVenda;

